import React from 'react';
import Box from '@material-ui/core/Box';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@material-ui/core/Link';

import Typography from '~/components/ui/Typography';

import PhoneVerificationForm from './PhoneVerificationForm';
import {ReactComponent as SVGPhoneMessaging} from './images/phone-messaging.svg';

type Props = {
  onSubmit: (codeString: string, formRef: null | HTMLFormElement) => void;
  resendCode: (isInitial?: boolean) => void;
  loading?: boolean;
  changePhoneLink?: string;
};

const PhoneVerification: React.FC<Props> = ({changePhoneLink, ...props}) => (
  <>
    <Box px={1} textAlign="center">
      <SVGPhoneMessaging />
      <Box mb={0.5}>
        <Typography variant="h2" heading>
          Enter a verification code
        </Typography>
      </Box>
    </Box>
    <Box className="text-center" mb={1.5}>
      We have sent an SMS with your
      <br />
      Verification Code. Please wait for the SMS
      <br />
      and enter your Code below.
    </Box>
    <PhoneVerificationForm {...props} />

    {changePhoneLink && (
      <Box mt={2.5} pt={1.5} className="divider-top text-center">
        <Link to={changePhoneLink} color="inherit" underline="always" component={RouterLink}>
          Mobile number changed?
        </Link>
      </Box>
    )}
  </>
);

export default PhoneVerification;
